module.exports = __webpack_public_path__ + "static/media/0.db9097e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/0.jpg
// module id = 22
// module chunks = 0